module.exports = __webpack_public_path__ + "static/img/2.e126024.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/2.jpg
// module id = c7i8
// module chunks = 12